import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchTMDBTVShows, clearTMDBTVShows } from "../slice/tmdbTVShowSlice";
import TMDBTVShow from "./TMDBTVShow";
import Spinner from "../util/Spinner";
import { filterTMDBTVShows } from "./TMDBTVShowUtil";

const AddTVShowToList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tvShowName, setTVShowName] = useState("");
  const [hasClickedSearch, setHasClickedSearch] = useState(false);
  // tmdb tv shows
  const { tmdbTVShows, isLoading } = useSelector((state) => {
    return state?.tmdbTVShows;
  });

  const goBack = () => {
    navigate(-1);
  };

  const handleTVShowNameSubmitted = async (e) => {
    e.preventDefault();
    try {
      dispatch(clearTMDBTVShows());
      setHasClickedSearch(true);
      const resultAction = await dispatch(fetchTMDBTVShows(tvShowName));
      if (fetchTMDBTVShows.fulfilled.match(resultAction)) {
        console.log("got tmdb tv shows: ", resultAction);
      } else {
        console.log("failed to get tmdb tv shows");
      }
    } catch (error) {
      console.log(
        "error getting tmdb tv shows, message: ",
        error?.response?.data?.errorMessage
      );
    } finally {
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      <form
        onSubmit={handleTVShowNameSubmitted}
        className="flex flex-col sm:flex-row gap-2 mb-4"
      >
        <input
          type="text"
          className="flex-1 border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600"
          placeholder="TV show name"
          value={tvShowName}
          onChange={(e) => setTVShowName(e.target.value)}
          required
        />
        <div className="flex gap-2 justify-end">
          <button type="button" onClick={goBack} className="btn-secondary">
            Cancel
          </button>
          <button
            type="submit"
            disabled={tvShowName.trim() === "" || isLoading}
            className="btn-primary"
          >
            {isLoading ? "Searching" : "Search"}
          </button>
        </div>
      </form>
      {hasClickedSearch ? (
        <div>
          {isLoading ? (
            <Spinner />
          ) : (
            <div className="space-y-3">
              {tmdbTVShows?.tvshows && tmdbTVShows?.tvshows?.length > 0 ? (
                filterTMDBTVShows(tmdbTVShows?.tvshows).map(
                  (tmdbTVShow, index) => {
                    return (
                      <TMDBTVShow
                        key={index}
                        tmdbTVShow={tmdbTVShow}
                      ></TMDBTVShow>
                    );
                  }
                )
              ) : (
                <div className="text-stone-500">Can't find that show</div>
              )}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default AddTVShowToList;
